export const TYPOGRAPHY = {
  biggerTitleSize48: '3rem',
  bodySize13: '0.8125rem',
  bodySize14: '0.875rem',
  bodySize16: '1rem',
  captionSize12: '0.75rem',
  subtitleSize20: '1.25rem',
  titleSize32: '2rem'
}
